import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIRoutes } from "APIRoutes";
import axios from "utils/axios";
import { utils } from "utils/utils";

export interface OnboardingDto {
  loading?: boolean;
  data: any[];
}

export const setOnboardingData = createAsyncThunk(
  "onboarding/setOnboardingData",
  async (data: any[]) => {
    return { data };
  }
);

export const getOnboardingData = createAsyncThunk(
  "onboarding/getOnboardingData",
  async () => {
    const response: any = await axios.get(APIRoutes.ONBOARDING);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? [] };
  }
);

export const addNewOnboarding = createAsyncThunk(
  "onboarding/addNewOnboarding",
  async (data: any) => {
    const response: any = await axios.post(APIRoutes.ONBOARDING, data);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? [] };
  }
);

export const updateOnboarding = createAsyncThunk(
  "onboarding/updateOnboarding",
  async ({ id, data }: { id: any; data: any }) => {
    const response: any = await axios.patch(
      `${APIRoutes.ONBOARDING}/${id || ""}`,
      data
    );
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

export const deleteOnboarding = createAsyncThunk(
  "onboarding/deleteOnboarding",
  async (id: number) => {
    const response: any = await axios.delete(`${APIRoutes.ONBOARDING}/${id}`);
    if (response.data?.statusCode) {
      utils.toastError(response.data?.message);
      return;
    }
    return { data: response?.data?.data ?? {} };
  }
);

const initialState: OnboardingDto = {
  loading: false,
  data: [],
};

export const onboarding = createSlice({
  name: "onboarding",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOnboardingData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOnboardingData.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload?.data;
      })
      .addCase(getOnboardingData.rejected, (state) => {
        state.loading = false;
      })
      .addCase(setOnboardingData.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.data = payload?.data ?? [];
      });
  },
});

export default onboarding.reducer;
